module.exports = __webpack_public_path__ + "static/kovka6-41c133982adbbda91bbfe094eb778778.png";